import VueI18Next from '@panter/vue-i18next';
import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';

/**
 * Configure how look up resource files
 * @type {{ALL: string, LANGUAGE_ONLY: string, LOCALE_ONLY: string}}
 */
export const LOADER_OPTIONS = {
  ALL: 'all', // ['en-US', 'en']
  LANGUAGE_ONLY: 'languageOnly', // 'en'
  LOCALE_ONLY: 'currentOnly' // 'en-US'
};

export function initI18n (App) {
  const languageModules = [];

  // Provide i18n configuration
  const config = App.config.i18n = {
    defaultLanguage: 'en-US',
    fallbackLanguage: 'en-US',
    languageLoader: LOADER_OPTIONS.LOCALE_ONLY,
    languageModules,
    defaultModule: null,
    moduleLocation: '/static/i18n/{{lng}}/{{ns}}.json',
    initOptions: {},
    instance: null
  };

  // Allow modules to extend the i18n service
  App.i18n = {};

  App.i18n.addNamespaces = (namespaces) => {
    if (!Array.isArray(namespaces)) {
      namespaces = [namespaces];
    }

    namespaces.forEach(n => { languageModules.push(n); });

    if (!config.defaultModule) {
      config.defaultModule = languageModules[0];
    }
  };

  // Support extending i18n formatters
  const formatters = {};
  function format (value, format, lang) {
    const formatter = formatters[format];
    return formatter ? formatter(value, lang) : value;
  }
  App.i18n.addFormatter = (key, cb) => {
    formatters[key] = cb;

    if (!config.initOptions.interpolation) {
      config.initOptions.interpolation = { format };
    }
  };

  // wargable
  App.i18n.init = () => createI18n(config);
}

// Exposed both on instance and global api. Probably a design problem here...
export function createI18n (config) {
  if (config.instance) {
    return Promise.resolve(config.instance);
  }

  config.instance = new VueI18Next(i18next);

  return new Promise((resolve, reject) => {
    // Visit https://www.i18next.com/ for more about using i18next.
    i18next
      .use(HttpApi)
      .init({
        lng: config.defaultLanguage,
        fallbackLng: config.fallbackLanguage,
        ns: config.languageModules,
        defaultNS: config.defaultModule,
        backend: {
          loadPath: config.moduleLocation
        },
        load: config.languageLoader,
        ...config.initOptions
      }, (error) => {
        if (error) {
          reject(new Error('Error starting i18n service. ' + error));
        }
        resolve(config.instance);
      });
  });
}
